import BasePopup from "../../../../src/scripts/classes/BasePopup";

var PopupUnit = function(options) {
	// Call parent constructor
	BasePopup.call(this, $.extend(true, {
		baseClass: 'el-PopupUnit',
		dotSelector: '.map-marker_icon-wrapper',
		popupSelector: '.map-marker_wrapper',
		pointerSelector: '.map-marker_pointer',
		componentName: 'PopupUnit'
	}, options));
};

// Inherit from BasePopup
PopupUnit.prototype = Object.create(BasePopup.prototype);
PopupUnit.prototype.constructor = PopupUnit;

export default PopupUnit;
